import { useQuery } from '@tanstack/react-query'
import { queryKeys } from '@/query/queryKeys'
import { fetchMyUsage, isUsageApiAvailable } from '@/services/usage/usageApi'

/**
 * Token usage for the signed-in user.
 *
 * @param {{ granularity?: string }} [options]
 */
export function useUsageSummary(options = {}) {
  const granularity = options.granularity ?? 'day'
  return useQuery({
    queryKey: queryKeys.usage.me(granularity),
    queryFn: ({ signal }) => fetchMyUsage({ granularity, signal }),
    enabled: isUsageApiAvailable(),
    staleTime: 60_000,
  })
}
